import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Sidebar from '../layouts/Sidebar';
import Topbar from '../layouts/Topbar';
import ChatWidget from '../features/chat/ChatWidget';
import { AuthenticatedRoutes, PublicRoutes } from './AppRoutes';
import { RealTimeChatProvider } from '../features/chat/context/RealTimeChatContext';
import ScrollToTop from '../shared/components/ScrollToTop';
import { useAccountAvatarSync } from '../features/profile';
import { LanguageProvider, LanguageSwitcher, TranslationManager } from '../features/translation';
import '../shared/styles/App.css';

function App() {
    const [user, setUser] = React.useState(() => {
        const storedUser = localStorage.getItem('user');
        return storedUser ? JSON.parse(storedUser) : null;
    });

    const [isLoggedIn, setIsLoggedIn] = React.useState(() => {
        return localStorage.getItem('access_token') !== null;
    });

    const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(true);
    const [globalSearch, setGlobalSearch] = React.useState('');

    const handleLogin = (status, userData) => {
        setIsLoggedIn(status);
        if (userData) setUser(userData);
    };

    // Changes to the logged-in user (e.g. a new profile picture) reach the top bar and side bar.
    const updateUser = React.useCallback((patch) => {
        setUser((previous) => {
            if (!previous) return previous;
            const changed = Object.keys(patch).some((key) => previous[key] !== patch[key]);
            if (!changed) return previous;
            const next = { ...previous, ...patch };
            localStorage.setItem('user', JSON.stringify(next));
            return next;
        });
    }, []);

    useAccountAvatarSync(user, isLoggedIn, updateUser);

    return (
        <Router>
            <ScrollToTop />
            <LanguageProvider>
            <TranslationManager />
            <RealTimeChatProvider isLoggedIn={isLoggedIn} user={user}>
                <div className={`App ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>

                    {isLoggedIn ? (
                        <>
                            <Sidebar
                                user={user}
                                isCollapsed={isSidebarCollapsed}
                                setIsCollapsed={setIsSidebarCollapsed}
                            />
                            <main className="main-content">
                                <Topbar
                                    user={user}
                                    globalSearch={globalSearch}
                                    setGlobalSearch={setGlobalSearch}
                                />
                                <div className="page-content-wrapper" style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                                    <AuthenticatedRoutes user={user} globalSearch={globalSearch} onUserUpdate={updateUser} />
                                </div>
                                <footer className="app-system-footer">
                                    Beta Version - In Demo Mode Copyright (C) of Exalogic Consulting - 2026
                                </footer>
                            </main>
                            <ChatWidget user={user} />
                        </>
                    ) : (
                        <PublicRoutes onLogin={handleLogin} />
                    )}
                    {/* Logged in: the switcher lives in the top bar. The login pages have no top bar. */}
                    {!isLoggedIn && <LanguageSwitcher placement="floating" />}
                </div>
            </RealTimeChatProvider>
            </LanguageProvider>
        </Router>
    );
}


export default App;
